import type { FormFieldControllerRulesProps } from '@bambi/component-library/src/components/forms/context/FormFieldController';
import type { TooltipPresentationOptions } from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';
import { minutesToSeconds, secondsToMinutes } from 'date-fns';

import { FormField } from './FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

interface SecondsToMinutesFieldProps {
  fieldPath: string;
  disabled?: boolean;
  label: string;
  tooltipHelper?: {
    text: string;
    presentation?: TooltipPresentationOptions;
  };
  inlineHelperText?: string;
  rules?: FormFieldControllerRulesProps;
  reserveErrorSpace?: boolean;
  placeholder?: string;
  emptyValue?: number | '' | null;
}

export default function SecondsToMinutesField({
  fieldPath,
  disabled,
  label,
  tooltipHelper,
  inlineHelperText,
  rules,
  reserveErrorSpace,
  placeholder,
  emptyValue = '',
}: SecondsToMinutesFieldProps) {
  tooltipHelper = tooltipHelper && {
    text: tooltipHelper.text,
    presentation: {
      type: 'tooltip',
      ...tooltipHelper.presentation,
    },
  };

  return (
    <FormFieldController name={fieldPath} rules={rules}>
      {({ field, fieldState }) => {
        const errorMessage = fieldState.error?.message?.toString();
        return (
          <>
            <FormField
              label={label}
              error={reserveErrorSpace ? undefined : errorMessage}
              helperText={tooltipHelper}
              type="number"
              placeholder={placeholder}
              inputProps={{
                id: fieldPath,
                ...field,
                placeholder,
                disabled,
                onChange: (e) => {
                  const value = e.target.value;
                  field.onChange(
                    value ? minutesToSeconds(parseInt(value, 10)) : emptyValue
                  );
                },
                value:
                  field.value != null && field.value !== ''
                    ? secondsToMinutes(field.value)
                    : (emptyValue ?? ''),
              }}
            />
            {reserveErrorSpace && (
              <p className="h-4 pt-1 text-xs text-red-500">
                {errorMessage ?? ' '}
              </p>
            )}
            {inlineHelperText && (
              <p className="pt-1 text-xs text-gray-500">{inlineHelperText}</p>
            )}
          </>
        );
      }}
    </FormFieldController>
  );
}
